var map = {
	"./1.pdf": 5675,
	"./10.pdf": 8137,
	"./11.pdf": 9764,
	"./12.pdf": 1563,
	"./13.pdf": 6894,
	"./14.pdf": 2413,
	"./15.pdf": 8344,
	"./16.pdf": 1663,
	"./2.pdf": 9332,
	"./3.pdf": 6521,
	"./4.pdf": 882,
	"./5.pdf": 9535,
	"./6.pdf": 7912,
	"./7.pdf": 2813,
	"./8.pdf": 6134,
	"./9.pdf": 4451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5536;